import React from 'react';

const Well = props => (
    <div className="well bs-component">
        {props.children}
    </div>
);

export default Well;